{
  "kostna-klinga": {
    "file": "kaykit/weapons/sword_C.glb",
    "bone": "handslotr",
    "scale": 0.78,
    "anchor": [
      0,
      0,
      0
    ],
    "rotation": [
      0,
      180,
      0
    ],
    "offset": [
      0,
      0.03,
      0
    ]
  },
  "runiczny-topor": {
    "file": "kaykit/weapons/axe_C.glb",
    "bone": "handslotr",
    "scale": 1.1,
    "anchor": [
      0,
      0,
      0
    ],
    "rotation": [
      0,
      90,
      0
    ],
    "offset": [
      0,
      0.03,
      0
    ]
  },
  "miecz-zlotej-strazy": {
    "file": "items/miecz-zlotej-strazy.glb",
    "bone": "handslotr",
    "scale": 1.8665,
    "anchor": [
      0.0004,
      -0.294,
      -0.0002
    ],
    "rotation": [
      0,
      180,
      0
    ],
    "offset": [
      0,
      0.03,
      0
    ]
  },
  "krysztalowy-kostur": {
    "file": "kaykit/weapons/staff_B.glb",
    "bone": "handslotr",
    "scale": 0.68,
    "anchor": [
      0,
      0,
      0
    ],
    "rotation": [
      0,
      180,
      0
    ],
    "offset": [
      0,
      0.03,
      0
    ]
  },
  "lesna-kusza": {
    "file": "items/lesna-kusza.glb",
    "bone": "handslotr",
    "scale": 1.7988,
    "anchor": [
      -0.0003,
      -0.0734,
      0.0001
    ],
    "rotation": [
      0,
      180,
      0
    ],
    "offset": [
      0,
      0.03,
      0
    ]
  },
  "miecz-rycerski": {
    "file": "kaykit/weapons/sword_E.glb",
    "bone": "handslotr",
    "scale": 0.48,
    "anchor": [
      0,
      0,
      0
    ],
    "rotation": [
      0,
      180,
      0
    ],
    "offset": [
      0,
      0.03,
      0
    ]
  },
  "dwureczny-miecz": {
    "file": "kaykit/weapons/sword_E.glb",
    "bone": "handslotr",
    "scale": 0.6,
    "anchor": [
      0,
      0,
      0
    ],
    "rotation": [
      0,
      180,
      0
    ],
    "offset": [
      0,
      0.03,
      0
    ]
  },
  "topor-bojowy": {
    "file": "kaykit/weapons/axe_A.glb",
    "bone": "handslotr",
    "scale": 1.0,
    "anchor": [
      0,
      0,
      0
    ],
    "rotation": [
      0,
      90,
      0
    ],
    "offset": [
      0,
      0.03,
      0
    ]
  },
  "wielki-topor": {
    "file": "kaykit/weapons/axe_B.glb",
    "bone": "handslotr",
    "scale": 0.95,
    "anchor": [
      0,
      0,
      0
    ],
    "rotation": [
      0,
      90,
      0
    ],
    "offset": [
      0,
      0.03,
      0
    ]
  },
  "kusza": {
    "file": "items/kusza.glb",
    "bone": "handslotr",
    "scale": 1.4183,
    "anchor": [
      0,
      -0.05,
      -0.017
    ],
    "rotation": [
      -90,
      30,
      -90
    ],
    "offset": [
      0,
      0.03,
      0
    ]
  },
  "ciezka-kusza": {
    "file": "items/ciezka-kusza.glb",
    "bone": "handslotr",
    "scale": 1.4529,
    "anchor": [
      -0.08,
      -0.08,
      0
    ],
    "rotation": [
      -90,
      30,
      -90
    ],
    "offset": [
      0,
      0.03,
      0
    ]
  },
  "sztylet": {
    "file": "kaykit/weapons/dagger_A.glb",
    "bone": "handslotr",
    "scale": 0.62,
    "anchor": [
      0,
      0,
      0
    ],
    "rotation": [
      0,
      180,
      0
    ],
    "offset": [
      0,
      0.03,
      0
    ]
  },
  "rozdzka": {
    "file": "kaykit/weapons/wand_A.glb",
    "bone": "handslotr",
    "scale": 0.78,
    "anchor": [
      0,
      0,
      0
    ],
    "rotation": [
      0,
      180,
      0
    ],
    "offset": [
      0,
      0.03,
      0
    ]
  },
  "kostur": {
    "file": "kaykit/weapons/staff_A.glb",
    "bone": "handslotr",
    "scale": 0.7,
    "anchor": [
      0,
      0,
      0
    ],
    "rotation": [
      0,
      180,
      0
    ],
    "offset": [
      0,
      0.03,
      0
    ]
  },
  "tarcza-okragla": {
    "file": "kaykit/weapons/shield_A.glb",
    "bone": "handslotl",
    "scale": 0.92,
    "anchor": [
      0,
      0,
      0
    ],
    "rotation": [
      0,
      0,
      0
    ],
    "offset": [
      0,
      0.02,
      0.16
    ]
  },
  "tarcza-z-herbem": {
    "file": "kaykit/weapons/shield_B.glb",
    "bone": "handslotl",
    "scale": 0.8,
    "anchor": [
      0,
      0,
      0
    ],
    "rotation": [
      0,
      0,
      0
    ],
    "offset": [
      0,
      0.02,
      0.16
    ]
  },
  "tarcza-kolczasta": {
    "file": "kaykit/weapons/shield_C.glb",
    "bone": "handslotl",
    "scale": 0.76,
    "anchor": [
      0,
      0,
      0
    ],
    "rotation": [
      0,
      0,
      0
    ],
    "offset": [
      0,
      0.02,
      0.16
    ]
  },
  "pawez": {
    "file": "kaykit/weapons/shield_C.glb",
    "bone": "handslotl",
    "scale": 0.84,
    "anchor": [
      0,
      0,
      0
    ],
    "rotation": [
      0,
      0,
      0
    ],
    "offset": [
      0,
      0.02,
      0.16
    ]
  },
  "tarcza-barbarzyncy": {
    "file": "kaykit/weapons/shield_A.glb",
    "bone": "handslotl",
    "scale": 0.88,
    "anchor": [
      0,
      0,
      0
    ],
    "rotation": [
      0,
      0,
      0
    ],
    "offset": [
      0,
      0.02,
      0.16
    ]
  },
  "topor-poreczny": {
    "file": "kaykit/weapons/axe_A.glb",
    "bone": "handslotl",
    "scale": 0.9,
    "anchor": [
      0,
      0,
      0
    ],
    "rotation": [
      0,
      90,
      0
    ],
    "offset": [
      0,
      0.03,
      0
    ]
  },
  "krotki-miecz": {
    "file": "kaykit/weapons/sword_B.glb",
    "bone": "handslotl",
    "scale": 0.72,
    "anchor": [
      0,
      0,
      0
    ],
    "rotation": [
      0,
      180,
      0
    ],
    "offset": [
      0,
      0.03,
      0
    ]
  },
  "noz-do-rzucania": {
    "file": "kaykit/weapons/dagger_B.glb",
    "bone": "handslotl",
    "scale": 0.6,
    "anchor": [
      0,
      0,
      0
    ],
    "rotation": [
      0,
      180,
      0
    ],
    "offset": [
      0,
      0.03,
      0
    ]
  },
  "ksiega-zaklec": {
    "file": "items/ksiega-zaklec.glb",
    "bone": "handslotl",
    "scale": 0.8,
    "anchor": [
      -0.0521,
      -0.0019,
      -0.0714
    ],
    "rotation": [
      0,
      0,
      90
    ],
    "offset": [
      0,
      0.02,
      0.16
    ]
  },
  "otwarta-ksiega": {
    "file": "items/otwarta-ksiega.glb",
    "bone": "handslotl",
    "scale": 0.9,
    "anchor": [
      0.0006,
      -0.002,
      -0.0063
    ],
    "rotation": [
      0,
      0,
      90
    ],
    "offset": [
      0,
      0.02,
      0.16
    ]
  },
  "helm-rycerski": {
    "file": "items/helm-rycerski.glb",
    "bone": "head",
    "scale": 1.3695,
    "anchor": [
      0.0058,
      -0.4204,
      -0.0007
    ],
    "rotation": [
      0,
      0,
      0
    ],
    "offset": [
      0,
      -0.94,
      0.06
    ]
  },
  "futrzana-czapa": {
    "file": "items/futrzana-czapa.glb",
    "bone": "head",
    "scale": 1.2133,
    "anchor": [
      0.0244,
      -0.2355,
      -0.0171
    ],
    "rotation": [
      0,
      0,
      0
    ],
    "offset": [
      0,
      -0.25,
      0.2
    ]
  },
  "spiczasty-kapelusz": {
    "file": "items/spiczasty-kapelusz.glb",
    "bone": "head",
    "scale": 1.5,
    "anchor": [
      0.004,
      -0.0599,
      -0.0009
    ],
    "rotation": [
      0,
      0,
      0
    ],
    "offset": [
      0,
      -0.03,
      0
    ]
  },
  "kaptur-zwiadowcy": {
    "file": "items/kaptur-zwiadowcy.glb",
    "bone": "head",
    "scale": 1.6,
    "anchor": [
      0.0006,
      -0.4152,
      -0.0002
    ],
    "rotation": [
      0,
      0,
      0
    ],
    "offset": [
      0,
      -0.6,
      0.06
    ]
  },
  "kapelusz-nekromanty": {
    "file": "items/kapelusz-nekromanty.glb",
    "bone": "head",
    "scale": 1.546,
    "anchor": [
      0.0799,
      -0.234,
      0.1425
    ],
    "rotation": [
      0,
      0,
      0
    ],
    "offset": [
      0.18,
      -0.18,
      0.36
    ]
  },
  "peleryna-rycerska": {
    "file": "items/peleryna-rycerska.glb",
    "bone": "chest",
    "scale": 1.2001,
    "anchor": [
      0.0006,
      0.5001,
      0.1437
    ],
    "rotation": [
      0,
      0,
      0
    ],
    "offset": [
      0,
      0.25,
      -0.04
    ]
  },
  "plaszcz-cienia": {
    "file": "items/plaszcz-cienia.glb",
    "bone": "chest",
    "scale": 1.2788,
    "anchor": [
      0.0614,
      0.501,
      0.3755
    ],
    "rotation": [
      0,
      0,
      0
    ],
    "offset": [
      0,
      0.25,
      -0.04
    ]
  },
  "plaszcz-gwiazd": {
    "file": "items/plaszcz-gwiazd.glb",
    "bone": "chest",
    "scale": 1.2705,
    "anchor": [
      0.0005,
      0.5007,
      0.1774
    ],
    "rotation": [
      0,
      0,
      0
    ],
    "offset": [
      0,
      0.25,
      -0.04
    ]
  },
  "postrzepiona-peleryna": {
    "file": "items/postrzepiona-peleryna.glb",
    "bone": "chest",
    "scale": 1.2221,
    "anchor": [
      0.0228,
      0.5012,
      0.1429
    ],
    "rotation": [
      0,
      0,
      0
    ],
    "offset": [
      0,
      0.25,
      -0.04
    ]
  },
  "skora-wilka": {
    "file": "items/skora-wilka.glb",
    "bone": "chest",
    "scale": 2.0932,
    "anchor": [
      -0.0007,
      0.2954,
      0.196
    ],
    "rotation": [
      0,
      0,
      0
    ],
    "offset": [
      0,
      0.25,
      -0.04
    ]
  }
}
